import {
    ActuatorsHomeAmDocument,
    ActuatorsHomeAmQuery, ActuatorsHomeAmQueryVariables, ActuatorsHomeApDocument,
    ActuatorsHomeApQuery, ActuatorsHomeApQueryVariables, ActuatorsHomeEuDocument,
    ActuatorsHomeEuQuery, ActuatorsHomeEuQueryVariables,
    RegionsEnum,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';

export type HomePageData = Omit<ActuatorsHomeEuQuery | ActuatorsHomeApQuery | ActuatorsHomeAmQuery, '__typename'>;
export type HomePageVariables = Omit<
ActuatorsHomeEuQueryVariables | ActuatorsHomeApQueryVariables | ActuatorsHomeAmQueryVariables, '__typename'
>;

export type HomePageConfig = {
    query: DocumentNode;
    filterConfig: FilterConfig;
}

export const getHomePageConfig = (region: RegionsEnum): HomePageConfig => {
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(ActuatorsHomeEuDocument),
            filterConfig: generateFiltersConfig(ActuatorsHomeEuDocument, 'values'),
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(ActuatorsHomeApDocument),
            filterConfig: generateFiltersConfig(ActuatorsHomeApDocument, 'values'),
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(ActuatorsHomeAmDocument),
            filterConfig: generateFiltersConfig(ActuatorsHomeAmDocument, 'values'),
        };
    }
    throw new Error('no page config');
};
